<template>
  <div class="ip-blacklist-container">
    
    
    <el-card class="search-card animate__animated animate__fadeInUp">
      <div slot="header" class="card-header">
        <span>封控列表</span>
      </div>
      
      <el-table
        :data="blacklistData.records"
        stripe
        style="width: 100%"
        v-loading="loading"
        class="animate__animated animate__fadeIn"
      >
        <el-table-column prop="ipAddress" label="IP地址" width="200"></el-table-column>
        <el-table-column prop="remainingMinutes" label="剩余时间" width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.remainingMinutes === '已过期/永久'" style="color: #F56C6C; font-weight: bold;">
              已过期/永久
            </span>
            <span v-else>
              {{ scope.row.remainingMinutes }} 分钟
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row.ipAddress)"
            >
              解封
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="blacklistData.total"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { get, request } from '@/utils/http';

export default {
  name: 'IpBlacklistManagement',
  data() {
    return {
      blacklistData: {
        records: [],
        total: 0,
        size: 10,
        current: 1
      },
      loading: false,
      currentPage: 1,
      pageSize: 10
    };
  },
  computed: {
    formattedBlacklistData() {
      // 将纯IP地址数组转换为包含IP地址和假时间的对象数组
      if (Array.isArray(this.blacklistData.records) && this.blacklistData.records.length > 0) {
        // 如果records是字符串数组（IP地址列表）
        if (typeof this.blacklistData.records[0] === 'string') {
          return this.blacklistData.records.map(ip => ({
            ipAddress: ip,
            createdAt: '' // 因为接口没有返回时间信息，暂时为空
          }));
        } else {
          // 如果records已经是对象数组，则直接返回
          return this.blacklistData.records;
        }
      }
      return [];
    }
  },
  async mounted() {
    await this.fetchBlacklistData();
  },
  methods: {
    async fetchBlacklistData() {
      this.loading = true;
      try {
        const response = await get(`/admin/ip-blacklist/list?pageNum=${this.currentPage}&pageSize=${this.pageSize}`);
        if (response && response.data) {
          this.blacklistData = response.data;
        }
      } catch (error) {
        console.error('获取IP封控列表失败:', error.message);
        this.$message.error('获取IP封控列表失败: ' + error.message);
      } finally {
        this.loading = false;
      }
    },
    async handleDelete(ipAddress) {
      // 清理IP地址，去掉 'loginIp:' 前缀
      let cleanIp = ipAddress;
      if (cleanIp.startsWith('loginIp:')) {
        cleanIp = cleanIp.substring(8);
      }
      
      this.$confirm(`确定要解封 IP 地址 "${cleanIp}" 吗？`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const params = new URLSearchParams();
          params.append('ipAddress', cleanIp);
          const response = await request(`/admin/ip-blacklist/delete?${params.toString()}`, {
            method: 'DELETE'
          });
          
          if (response && response.code === 200) {
            this.$message.success(response.data || '解封成功');
            await this.fetchBlacklistData();
          } else {
            this.$message.error(response.msg || '解封失败');
          }
        } catch (error) {
          console.error('解封IP失败:', error.message);
          this.$message.error('解封失败: ' + error.message);
        }
      }).catch(() => {
        // 用户取消操作
      });
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.currentPage = 1; // 重置到第一页
      this.fetchBlacklistData();
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.fetchBlacklistData();
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    }
  }
};
</script>

<style scoped>
.ip-blacklist-container {
}

.page-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #e2e8f0;
  text-align: center;
}

.search-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.card-header {
  font-weight: bold;
  font-size: 16px;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.table-operation {
  display: flex;
  gap: 10px;
}

/* Speed up animations */
.el-card.animate__animated,
.el-table.animate__animated {
  --animate-duration: 0.3s;
}
</style>